<template>
	<page-view title>
		<div slot="headerContent"></div>
		<div :style="{ marginBottom: '10px' }">
			<demo-video-alert name="ChaJianSheZhe"></demo-video-alert>
		</div>
		<a-spin :spinning="PullLoading">
			<a-card title="查券功能" :bordered="false">
				<template slot="extra">
					<search-robot-input class="search-robot-input" :showInfo="false" :selectFirst="false"
						primaryBtnText="拉取配置" @changeRobotId="onChangeRobotId"></search-robot-input>
				</template>

				<a-alert v-if="!robotid" :style="{ margin: '10px 0 20px 0' }" message="重要提醒"
					description="当前显示的系统默认数据，如需加载指定机器人数据请在右上角输入框进行拉取配置操作。" type="warning" show-icon />
				<a-alert v-if="robotid" :style="{ margin: '10px 0 20px 0' }" message="已经拉取机器人配置" type="success"
					show-icon />

				
						<a-form id="form" :form="form" @submit="handleSubmit">
							<a-form-item label="是否开启" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-switch v-decorator="['isok', { initialValue: true, valuePropName: 'checked' }]" />
							</a-form-item>
							<a-divider :dashed="true" />
							<a-form-item
				        label="识别淘口令"
				        help="关闭后不再识别淘口令"
				        :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
				        :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
				      >
				        <a-switch v-decorator="['sbtkl', { initialValue: true, valuePropName: 'checked' }]" />
				      </a-form-item>
				      <a-form-item
				        label="识别商品链接"
				        help="关闭后不再识别淘宝链接"
				        :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
				        :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
				      >
				        <a-switch v-decorator="['sburl', { initialValue: true, valuePropName: 'checked' }]" />
				      </a-form-item>
				      <a-form-item
				        label="识别拼多多商品"
				        help="关闭后不再识别拼多多商品"
				        :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
				        :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
				      >
				        <a-switch v-decorator="['sbpdd', { initialValue: true, valuePropName: 'checked' }]" />
				      </a-form-item>
				      <a-form-item
				        label="识别京东商品"
				        help="关闭后不再识别京东商品"
				        :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
				        :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
				      >
				        <a-switch v-decorator="['sbjd', { initialValue: true, valuePropName: 'checked' }]" />
				      </a-form-item>
				      <a-form-item
				        label="识别唯品会商品"
				        help="关闭后不再识别唯品会商品"
				        :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
				        :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
				      >
				        <a-switch v-decorator="['recognize_vph', { initialValue: true, valuePropName: 'checked' }]" />
				      </a-form-item>
				      <a-form-item
				        label="识别抖Y商品"
				        help="关闭后不再识别抖Y商品"
				        :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
				        :wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
				      >
				        <a-switch v-decorator="['sbdy', { initialValue: true, valuePropName: 'checked' }]" />
				      </a-form-item>
					
					
							<a-form-item label="追单匹配订单尾号" help="开启后，启用淘宝尾号匹配追单，关闭后仅使用查券记录追单，建议开启"
								:label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-switch v-decorator="['zdgd_wh', { initialValue: true, valuePropName: 'checked' }]" />
							</a-form-item>
							<a-form-item label="首单使用副联盟" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }" :style="{ display: 'none' }">
								<a-switch v-decorator="['sdfhlm', { initialValue: true, valuePropName: 'checked' }]" />
							</a-form-item>
							<a-form-item label="前几单使用副联盟" help="填0为不使用，当总订单数（付款+结算）超过设置订单数后才会使用主联盟"
								:label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-input-number :min="0" v-decorator="['sub_union_order_num', { initialValue: 0 }]" />
							</a-form-item>
							<a-form-item v-show="false" label="查询设置" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-radio-group :options="[
									{ label: '所有人可以查询', value: 1 },
									{ label: '仅限会员查询', value: 2 },
									{ label: '仅私聊可查询', value: 3 },
								]" v-decorator="['userxz', { initialValue: 1 }]" />
							</a-form-item>
							<a-form-item label="回复设置" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-radio-group :options="[
									{ label: '中间页卡片独立模式', value: 1 },
									{ label: '文本回复综合模式', value: 2 },
								]" v-decorator="['huifulx', { initialValue: 1 }]" />
							</a-form-item>
							<a-form-item label="淘宝查券回复小程序" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-switch
									v-decorator="['reply_min_program', { initialValue: false, valuePropName: 'checked' }]" />
							</a-form-item>
							<a-form-item v-if="false" label="抖Y是否使用文本回复"
								:label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-switch
									v-decorator="['is_dy_reply_text', { initialValue: false, valuePropName: 'checked' }]" />
							</a-form-item>
							<!-- -->
							<div v-show="formData['reply_min_program']">
								<a-form-item label="小程序中间页类型" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<!-- <a-radio-group
					                  :options="[
					                    { label: '好物推荐中间页', value: 1 },
					                    { label: '在线赚钱中间页', value: 2 }
					                  ]"
					                  v-decorator="['min_program_page_type', { initialValue: 1 }]"
					                /> -->
									<a-radio-group v-decorator="['min_program_page_type', { initialValue: 1 }]">
										<a-radio value="1"> 好物推荐中间页 </a-radio>
										<a-radio value="2"> 在线赚钱中间页 </a-radio>
										<a-radio value="3"> 淘宝定投活动中间页 </a-radio>
										<a-radio value="4"> 双十一活动中间页 </a-radio>
										<a-icon type="question-circle" :style="{ color: '#1890ff' }"
											@click="minProgramShowModal" />
									</a-radio-group>
								</a-form-item>
								<a-form-item label="自定义小程序封面" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<div style="display:flex">
										<a-textarea placeholder="请输入自定义封面参数"
											v-decorator="['min_program_cover_params']" />
										<a-icon type="question-circle"
											:style="{ fontSize: '20px', color: '#1890ff', marginLeft: '6px' }"
											@click="demoSetVideo('MiniProgranmCustomCover')" />
									</div>
								</a-form-item>
							</div>
							<div v-show="formData['huifulx'] == 2">
								<a-form-item label="是否回复商品图" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-switch
										v-decorator="['hftxtimg', { initialValue: true, valuePropName: 'checked' }]" />
								</a-form-item>
							</div>
							<a-modal :width="700" @ok="cardSettingOk" @cancel="visible = false" ok-text="确定"
								cancel-text="取消" :visible="visible" title="中间页卡片设置">
								<div style="max-height: 500px; overflow-y: auto">
									<a-form-item label="[券信息]" :label-col="{ xs: { span: 24 }, sm: { span: 8 } }"
										:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
										<a-input placeholder="请输入"
											v-decorator="['coupons_info', { initialValue: '[标题]' }]" />
										<div slot="extra">
											<a-tag @click="doCopy(`[券面值]`)">[券面值]</a-tag>
										</div>
									</a-form-item>
									<a-form-item label="淘宝商品卡片-标题" :label-col="{ xs: { span: 24 }, sm: { span: 8 } }"
										:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
										<a-input placeholder="请输入"
											v-decorator="['tb_card_title', { initialValue: '[标题]' }]" />
										<div slot="extra">
											<a-tag @click="doCopy(`[标题]`)">[标题]</a-tag>
											<a-tag @click="doCopy(`[原价]`)">[原价]</a-tag>
											<a-tag @click="doCopy(`[券后价]`)">[券后价]</a-tag>
											<a-tag @click="doCopy(`[券面值]`)">[券面值]</a-tag>
											<a-tag @click="doCopy(`[约返利]`)">[约返利]</a-tag>
											<a-tag @click="doCopy(`[券信息]`)">[券信息]</a-tag>
											<a-tag @click="doCopy(`[到手价]`)">[到手价]</a-tag>
										</div>
									</a-form-item>
									<a-form-item label="淘宝商品卡片-描述" :label-col="{ xs: { span: 24 }, sm: { span: 8 } }"
										:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
										<a-textarea placeholder="请输入"
											v-decorator="['tb_card_desc', { initialValue: '[标题]' }]" />
										<div slot="extra">
											<a-tag @click="doCopy(`[标题]`)">[标题]</a-tag>
											<a-tag @click="doCopy(`[原价]`)">[原价]</a-tag>
											<a-tag @click="doCopy(`[券后价]`)">[券后价]</a-tag>
											<a-tag @click="doCopy(`[券面值]`)">[券面值]</a-tag>
											<a-tag @click="doCopy(`[约返利]`)">[约返利]</a-tag>
											<a-tag @click="doCopy(`[券信息]`)">[券信息]</a-tag>
											<a-tag @click="doCopy(`[到手价]`)">[到手价]</a-tag>
										</div>
									</a-form-item>
									<a-form-item label="京东商品卡片-标题" :label-col="{ xs: { span: 24 }, sm: { span: 8 } }"
										:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
										<a-input placeholder="请输入"
											v-decorator="['jd_card_title', { initialValue: '[标题]' }]" />
										<div slot="extra">
											<a-tag @click="doCopy(`[标题]`)">[标题]</a-tag>
											<a-tag @click="doCopy(`[原价]`)">[原价]</a-tag>
											<a-tag @click="doCopy(`[券后价]`)">[券后价]</a-tag>
											<a-tag @click="doCopy(`[券面值]`)">[券面值]</a-tag>
											<a-tag @click="doCopy(`[约返利]`)">[约返利]</a-tag>
											<a-tag @click="doCopy(`[券信息]`)">[券信息]</a-tag>
											<a-tag @click="doCopy(`[到手价]`)">[到手价]</a-tag>
										</div>
									</a-form-item>
									<a-form-item label="京东商品卡片-描述" :label-col="{ xs: { span: 24 }, sm: { span: 8 } }"
										:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
										<a-textarea placeholder="请输入"
											v-decorator="['jd_card_desc', { initialValue: '[标题]' }]" />
										<div slot="extra">
											<a-tag @click="doCopy(`[标题]`)">[标题]</a-tag>
											<a-tag @click="doCopy(`[原价]`)">[原价]</a-tag>
											<a-tag @click="doCopy(`[券后价]`)">[券后价]</a-tag>
											<a-tag @click="doCopy(`[券面值]`)">[券面值]</a-tag>
											<a-tag @click="doCopy(`[约返利]`)">[约返利]</a-tag>
											<a-tag @click="doCopy(`[券信息]`)">[券信息]</a-tag>
											<a-tag @click="doCopy(`[到手价]`)">[到手价]</a-tag>
										</div>
									</a-form-item>
									<a-form-item label="拼多多商品卡片-标题" :label-col="{ xs: { span: 24 }, sm: { span: 8 } }"
										:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
										<a-input placeholder="请输入"
											v-decorator="['pdd_card_title', { initialValue: '[标题]' }]" />
										<div slot="extra">
											<a-tag @click="doCopy(`[标题]`)">[标题]</a-tag>
											<a-tag @click="doCopy(`[原价]`)">[原价]</a-tag>
											<a-tag @click="doCopy(`[券后价]`)">[券后价]</a-tag>
											<a-tag @click="doCopy(`[券面值]`)">[券面值]</a-tag>
											<a-tag @click="doCopy(`[约返利]`)">[约返利]</a-tag>
											<a-tag @click="doCopy(`[券信息]`)">[券信息]</a-tag>
											<a-tag @click="doCopy(`[到手价]`)">[到手价]</a-tag>
										</div>
									</a-form-item>
									<a-form-item label="拼多多商品卡片-描述" :label-col="{ xs: { span: 24 }, sm: { span: 8 } }"
										:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
										<a-textarea placeholder="请输入"
											v-decorator="['pdd_card_desc', { initialValue: '[标题]' }]" />
										<div slot="extra">
											<a-tag @click="doCopy(`[标题]`)">[标题]</a-tag>
											<a-tag @click="doCopy(`[原价]`)">[原价]</a-tag>
											<a-tag @click="doCopy(`[券后价]`)">[券后价]</a-tag>
											<a-tag @click="doCopy(`[券面值]`)">[券面值]</a-tag>
											<a-tag @click="doCopy(`[约返利]`)">[约返利]</a-tag>
											<a-tag @click="doCopy(`[券信息]`)">[券信息]</a-tag>
											<a-tag @click="doCopy(`[到手价]`)">[到手价]</a-tag>
										</div>
									</a-form-item>

									<a-form-item label="唯品会商品卡片-标题" :label-col="{ xs: { span: 24 }, sm: { span: 8 } }"
										:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
										<a-input placeholder="请输入"
											v-decorator="['wph_card_title', { initialValue: '[标题]' }]" />
										<div slot="extra">
											<a-tag @click="doCopy(`[标题]`)">[标题]</a-tag>
											<a-tag @click="doCopy(`[原价]`)">[原价]</a-tag>
											<a-tag @click="doCopy(`[券后价]`)">[券后价]</a-tag>
											<a-tag @click="doCopy(`[券面值]`)">[券面值]</a-tag>
											<a-tag @click="doCopy(`[约返利]`)">[约返利]</a-tag>
											<a-tag @click="doCopy(`[券信息]`)">[券信息]</a-tag>
											<a-tag @click="doCopy(`[到手价]`)">[到手价]</a-tag>
										</div>
									</a-form-item>
									<a-form-item label="唯品会商品卡片-描述" :label-col="{ xs: { span: 24 }, sm: { span: 8 } }"
										:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
										<a-textarea placeholder="请输入"
											v-decorator="['wph_card_desc', { initialValue: '[标题]' }]" />
										<div slot="extra">
											<a-tag @click="doCopy(`[标题]`)">[标题]</a-tag>
											<a-tag @click="doCopy(`[原价]`)">[原价]</a-tag>
											<a-tag @click="doCopy(`[券后价]`)">[券后价]</a-tag>
											<a-tag @click="doCopy(`[券面值]`)">[券面值]</a-tag>
											<a-tag @click="doCopy(`[约返利]`)">[约返利]</a-tag>
											<a-tag @click="doCopy(`[券信息]`)">[券信息]</a-tag>
											<a-tag @click="doCopy(`[到手价]`)">[到手价]</a-tag>
										</div>
									</a-form-item>
									<a-form-item label="抖Y商品卡片-标题" :label-col="{ xs: { span: 24 }, sm: { span: 8 } }"
										:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
										<a-input placeholder="请输入"
											v-decorator="['dy_card_title', { initialValue: '[标题]' }]" />
										<div slot="extra">
											<a-tag @click="doCopy(`[标题]`)">[标题]</a-tag>
											<a-tag @click="doCopy(`[原价]`)">[原价]</a-tag>
											<a-tag @click="doCopy(`[券后价]`)">[券后价]</a-tag>
											<a-tag @click="doCopy(`[券面值]`)">[券面值]</a-tag>
											<a-tag @click="doCopy(`[约返利]`)">[约返利]</a-tag>
											<a-tag @click="doCopy(`[券信息]`)">[券信息]</a-tag>
											<a-tag @click="doCopy(`[到手价]`)">[到手价]</a-tag>
										</div>
									</a-form-item>
									<a-form-item label="抖Y商品卡片-描述" :label-col="{ xs: { span: 24 }, sm: { span: 8 } }"
										:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
										<a-textarea placeholder="请输入"
											v-decorator="['dy_card_desc', { initialValue: '[标题]' }]" />
										<div slot="extra">
											<a-tag @click="doCopy(`[标题]`)">[标题]</a-tag>
											<a-tag @click="doCopy(`[原价]`)">[原价]</a-tag>
											<a-tag @click="doCopy(`[券后价]`)">[券后价]</a-tag>
											<a-tag @click="doCopy(`[券面值]`)">[券面值]</a-tag>
											<a-tag @click="doCopy(`[约返利]`)">[约返利]</a-tag>
											<a-tag @click="doCopy(`[券信息]`)">[券信息]</a-tag>
											<a-tag @click="doCopy(`[到手价]`)">[到手价]</a-tag>
										</div>
									</a-form-item>
								</div>
							</a-modal>
							<!-- 小程序标题弹框 -->
							<a-modal :width="700" @ok="minCardSettingOk" @cancel="minVisible = false" ok-text="确定"
								cancel-text="取消" :visible="minVisible" title="中间页卡片设置">
								<div style="max-height: 500px; overflow-y: auto">
									<a-form-item label="小程序-标题" :label-col="{ xs: { span: 24 }, sm: { span: 6 } }"
										:wrapper-col="{ xs: { span: 24 }, sm: { span: 14 } }">
										<a-input placeholder="请输入"
											v-decorator="['minProgram_card_title', { initialValue: '[标题]' }]" />
										<div slot="extra">
											<a-tag @click="doCopy(`[标题]`)">[标题]</a-tag>
											<a-tag @click="doCopy(`[原价]`)">[原价]</a-tag>
											<a-tag @click="doCopy(`[券后价]`)">[券后价]</a-tag>
											<a-tag @click="doCopy(`[券面值]`)">[券面值]</a-tag>
											<a-tag @click="doCopy(`[约返利]`)">[约返利]</a-tag>
											<a-tag @click="doCopy(`[券信息]`)">[券信息]</a-tag>
											<a-tag @click="doCopy(`[到手价]`)">[到手价]</a-tag>
										</div>
									</a-form-item>
								</div>
							</a-modal>
							<div v-show="formData['huifulx'] == 1">
								<a-form-item label="设置商品卡片" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-button type="link" @click="settingCard">立即设置</a-button>
								</a-form-item>
							</div>
							<a-form-item label="设置小程序标题" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-button type="link" @click="settingMinProgramCard">立即设置</a-button>
							</a-form-item>
							<!-- <a-form-item
					              label="使用带商品中间页"
					              :label-col="{xs: { span: 24 },sm: { span: 4 }}"
					              :wrapper-col="{xs: { span: 24 },sm: { span: 10 }}"
					            >
					              <a-switch
					                v-decorator="['super_zjyurl_switch', {initialValue: false, valuePropName: 'checked'}]"
					              />
					            </a-form-item>-->
							<a-form-item label="设置自定义中间页域名" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-button type="link" @click="settingDomain">立即设置</a-button>
							</a-form-item>
							<a-modal :width="700" @ok="domainSettingOk" @cancel="domainVisible = false" ok-text="确定"
								cancel-text="取消" :visible="domainVisible" title="自定义域名设置">
								<div style="max-height: 500px; overflow-y: auto">
									<a-form-item v-if="true" v-show="!formData['super_zjyurl_switch']" label="固定自定义域名"
										help="如果您的自定义中间页包含&符号，请基础设置中必须选择短链接！[长口令] 支持IOS 14 设备，留空则使用官方中间页"
										:label-col="{ xs: { span: 24 }, sm: { span: 8 } }"
										:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
										<a-input-group style="display: inline-flex">
											<a-col style="flex: 1">
												<a-input placeholder="中间页链接" v-decorator="['zjyurl']" />
											</a-col>
											<!-- <a-col style="margin-left:16px;">
					                      <a-button type="primary">下载中间页源码.zip</a-button>
					                    </a-col>-->
										</a-input-group>
										<div slot="extra">
											<a-tag @click="doCopy(`[淘口令]`)">[淘口令]</a-tag>
											<a-tag @click="doCopy(`[长口令]`)">[长口令]</a-tag>
											<a-tag @click="doCopy(`[商品图片]`)">[商品图片]</a-tag>
											<a-tag @click="doCopy(`[数据]`)">[数据]</a-tag>
											<a-tag @click="doCopy(`[淘客链接]`)">[淘客链接]</a-tag>
										</div>
									</a-form-item>
									<a-form-item label="是否开启自定义域名池" :label-col="{ xs: { span: 24 }, sm: { span: 8 } }"
										:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
										<a-switch
											v-decorator="['domain_pool_switch', { valuePropName: 'checked', initialValue: true }]" />
									</a-form-item>
									<a-form-item label="官方中间页设置" :label-col="{ xs: { span: 24 }, sm: { span: 8 } }"
										:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
										<a-radio-group v-decorator="['pages_type', { initialValue: 1 }]">
											<a-radio :value="1">默认中间页01</a-radio>
											<!-- <a-radio :value="2">双十一活动中间页</a-radio> -->
										</a-radio-group>
									</a-form-item>
									<a-form-item label="自定义域名池" :label-col="{ xs: { span: 24 }, sm: { span: 8 } }"
										:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
										<!-- <a-switch v-decorator="['domain_pool_switch', {valuePropName: 'checked'}]" /> -->
										<a @click="$refs.domain_list.show()">域名列表</a>
									</a-form-item>
								</div>
							</a-modal>

							<a-form-item v-show="false" label="自定义淘口令标题"
								:label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
								extra="打开手机淘宝弹出口令商品时显示的标题（长度必须5个字符以上）">
								<a-input-group style="display: inline-flex">
									<a-col style="flex: 1">
										<a-input placeholder="淘口令标题" v-decorator="['taotitle']" />
									</a-col>
								</a-input-group>
							</a-form-item>
							<a-divider :dashed="true" />
							<a-form-item label="自定义口令识别符" help="替换文本回复模式和发送朋友圈中的口令前后符号，防止微信风控和屏蔽"
								:label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-switch
									v-decorator="['identity_switch', { initialValue: false, valuePropName: 'checked' }]" />
							</a-form-item>
							<div v-show="formData['identity_switch'] == true">
								<a-form-item label="口令识别前缀后缀" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }" extra="请使用英文字符，中文字符淘宝不识别">
									<a-input-group compact style="display: inline-flex">
										<a-form-item
											:style="{ display: 'inline-block', width: 'calc(50% - 12px)', marginBottom: '0' }">
											<a-input style="text-align: center" placeholder="口令标识前缀"
												v-decorator="['identity_prefix']" />
										</a-form-item>
										<span
											:style="{ display: 'inline-block', width: '24px', textAlign: 'center', lineHeight: '36px' }">-</span>
										<a-form-item
											:style="{ display: 'inline-block', borderLeft: '0', width: 'calc(50% - 12px)', marginBottom: '0' }">
											<a-input style="text-align: center" placeholder="口令标识后缀"
												v-decorator="['identity_suffix']" />
										</a-form-item>
									</a-input-group>
								</a-form-item>
							</div>
							<a-divider :dashed="true" />
							<a-form-item label="消息回复延迟(秒)" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }" extra="不填则不延迟">
								<a-input-number :min="0" :max="5"
									v-decorator="['message_delay', { initialValue: 0 }]" />
							</a-form-item>
					
				
							<a-form-item label="促单消息" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }"
								extra="促单消息配置，需重启生效，如果用户已经存在订单（付款+结算）将不再发送此消息！">
								<a-switch
									v-decorator="['promote_pay_switch', { initialValue: false, valuePropName: 'checked' }]" />
							</a-form-item>
							<div v-show="formData['promote_pay_switch'] == true">
								<a-form-item label="等待购买时间(秒)" extra="查券后等待购买时间"
									:label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-input-number :min="1" v-decorator="['promote_pay_delay']" />
								</a-form-item>
								<a-form-item label="促单消息次数"
									help="从添加好友开始，发送多少次促单消息（同一个商品只发送第一次，假如设置为2，用户添加后前两次查询发送促单，以后不再发送给这个用户，如果用户产生订单也不再发送）"
									:label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-input-number :min="1" v-decorator="['promote_pay_num', { initialValue: 1 }]" />
								</a-form-item>
								<a-form-item label="促单消息内容" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-textarea ref="promote_pay_message" :rows="6" placeholder="请输入" v-decorator="[
										'promote_pay_message',
										{
											initialValue: `您查询的“[商品标题]”
															收货后可以领取[约返利]元返现，到手价才[到手价]元，快来下单吧~`,
										},
									]" />
									<div slot="extra">
										<emoji-dialog @cencel="setEmoji" input="promote_pay_message" />
										<a-tag @click="doCopy(`[昵称]`)">[昵称]</a-tag>
										<a-tag @click="doCopy(`[商品标题]`)">[商品标题]</a-tag>
										<a-tag @click="doCopy(`[商城链接]`)">[商城链接]</a-tag>
										<a-tag @click="doCopy(`[原价]`)">[原价]</a-tag>
										<a-tag @click="doCopy(`[券面值]`)">[券面值]</a-tag>
										<a-tag @click="doCopy(`[券后价]`)">[券后价]</a-tag>
										<a-tag @click="doCopy(`[约返利]`)">[约返利]</a-tag>
										<a-tag @click="doCopy(`[到手价]`)">[到手价]</a-tag>
										<a-tag @click="doCopy(`[共节省]`)">[共节省]</a-tag>
									</div>
								</a-form-item>
							</div>
					
							<a-form-item label="首次查券后补充消息" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }" extra="首次查券后，经过间隔时间发送此消息">
								<a-switch
									v-decorator="['first_order_extend_switch', { initialValue: false, valuePropName: 'checked' }]" />
							</a-form-item>
							<div v-show="form.getFieldValue('first_order_extend_switch')">
								<a-form-item label="间隔时间(秒)" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-input-number :min="1"
										v-decorator="['first_order_extend_time', { initialValue: 10 }]" />
								</a-form-item>
								<a-form-item label="消息内容" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-textarea ref="first_order_extend_content" :rows="6" placeholder="请输入"
										v-decorator="[
											'first_order_extend_content',
											{ initialValue: `恭喜您首次下单，额外奖励您一个首单红包哦！~` },
										]" />
									<div slot="extra">
										<emoji-dialog @cencel="setEmoji" input="first_order_extend_content" />
										<a-tag @click="doCopy(`[昵称]`)">[昵称]</a-tag>
									</div>
								</a-form-item>
							</div>
							<a-divider :dashed="true" />
							<a-form-item label="查询无券消息提醒" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-textarea ref="No_coupon_reminder" :rows="6" placeholder="请输入" v-decorator="[
									'No_coupon_reminder',
									{
										initialValue: `[委屈]您查询的：[标题]
															[红包]优惠券被抢光了，不过还是有[约返利]元返利红包可以领取哦，点击卡片下单吧~`,
									},
								]" />
								<div slot="extra">
									<emoji-dialog @cencel="setEmoji" input="No_coupon_reminder" />
									<a-tag @click="doCopy(`[昵称]`)">[昵称]</a-tag>
									<a-tag @click="doCopy(`[标题]`)">[标题]</a-tag>
									<a-tag @click="doCopy(`[原价]`)">[原价]</a-tag>
									<a-tag @click="doCopy(`[约返利]`)">[约返利]</a-tag>
									<a-tag @click="doCopy(`[券面值]`)">[券面值]</a-tag>
								</div>
							</a-form-item>
							<a-divider :dashed="true" />
							<a-form-item label="查询有券消息提醒" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-textarea ref="coupon_reminder" :rows="6" placeholder="请输入" v-decorator="[
									'coupon_reminder',
									{
										initialValue: `[委屈]您查询的：[标题]
															[红包]优惠券被抢光了，不过还是有[约返利]元返利红包可以领取哦，点击卡片下单吧~`,
									},
								]" />
								<div slot="extra">
									<emoji-dialog @cencel="setEmoji" input="coupon_reminder" />
									<a-tag @click="doCopy(`[昵称]`)">[昵称]</a-tag>
									<a-tag @click="doCopy(`[标题]`)">[标题]</a-tag>
									<a-tag @click="doCopy(`[原价]`)">[原价]</a-tag>
									<a-tag @click="doCopy(`[约返利]`)">[约返利]</a-tag>
									<a-tag @click="doCopy(`[券面值]`)">[券面值]</a-tag>
								</div>
							</a-form-item>
					
							<a-form-item label="促绑消息开关" help="促绑消息开启后将不会再发送促单消息，开启后如遇到无法确定归属的订单，将发送此消息给所有查询过此商品的用户"
								:label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-switch
									v-decorator="['promote_bind_switch', { initialValue: false, valuePropName: 'checked' }]" />
							</a-form-item>
							<div v-show="formData['promote_bind_switch'] == true">
								<a-form-item label="等待绑定时间（秒）" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-input-number :min="0" :max="30" v-decorator="['promote_bind_delay']" />
								</a-form-item>
								<a-form-item label="促绑消息内容" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-textarea ref="promote_bind_message" :rows="6" placeholder="请输入" v-decorator="[
										'promote_bind_message',
										{
											initialValue: `您查询的：
																”[商品标题]“
																如果已经购买记得发下订单号给我哦~`,
										},
									]" />
									<div slot="extra">
										<emoji-dialog @cencel="setEmoji" input="promote_bind_message" />
										<a-tag @click="doCopy(`[商品标题]`)">[商品标题]</a-tag>
										<a-tag @click="doCopy(`[付款金额]`)">[付款金额]</a-tag>
									</div>
								</a-form-item>
							</div>
						
							<!-- 激活用户促查开关 -->
							<a-form-item label="激活用户促查开关" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-switch
									v-decorator="['active_switch', { initialValue: false, valuePropName: 'checked' }]" />
							</a-form-item>
							<div v-show="formData['active_switch'] == true">
								<a-form-item label="超过" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-input-number :min="1"
										v-decorator="['active_expire_days', { initialValue: 10 }]" />
									天未查卷
								</a-form-item>
								<a-form-item label="激活用户催促内容" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-textarea ref="active_message" :rows="6" placeholder="请输入" v-decorator="[
										'active_message',
										{
											initialValue: ``,
										},
									]" />
									<div slot="extra">
										<emoji-dialog @cencel="setEmoji" input="active_message" />
									</div>
								</a-form-item>
								<a-form-item label="激活后首次查券奖励" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-input-number :min="0" style="width:80px"
										v-decorator="['activation_search_reward']" />元，首次下单奖励
									<a-input-number :min="0" style="width:80px"
										v-decorator="['activation_deal_reward']" />元 （最低0.3元，低于0.3发送失败奖励）
										<!-- （设置金额不能小于0.3元） -->
								</a-form-item>
							</div>
						
							<a-form-item label="催促查券消息" help="通过好友后，经过间隔时间发送此消息，如果已经查过卷则不发送"
								:label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-switch
									v-decorator="['promote_search_switch', { initialValue: false, valuePropName: 'checked' }]" />
							</a-form-item>
							<div v-show="formData['promote_search_switch'] == true">
								<a-form-item label="第一条间隔时间(秒)" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-input-number :min="0" v-decorator="['promote_search_one_delay']" />
								</a-form-item>
								<!-- <a-form-item
							    label="发送次数"
							    :label-col="{xs: { span: 24 },sm: { span: 4 }}"
							    :wrapper-col="{xs: { span: 24 },sm: { span: 10 }}"
							  >
							    <a-input-number :max="3" v-decorator="['promote_search_num']" />
							  </a-form-item> -->
								<a-form-item label="第一条催促消息内容" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-textarea ref="promote_search_one_message" :rows="6" placeholder="请输入"
										v-decorator="['promote_search_one_message']" />
									<div slot="extra">
										<emoji-dialog @cencel="setEmoji" input="promote_search_one_message" />
										<a-tag @click="doCopy(`[昵称]`)">[昵称]</a-tag>
									</div>
								</a-form-item>
								<a-form-item label="第二条间隔时间(秒)" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-input-number :min="0" v-decorator="['promote_search_two_delay']" />
								</a-form-item>
								<a-form-item label="第二条催促消息内容" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-textarea ref="promote_search_two_message" :rows="6" placeholder="请输入"
										v-decorator="['promote_search_two_message']" />
									<div slot="extra">
										<emoji-dialog @cencel="setEmoji" input="promote_search_two_message" />
										<a-tag @click="doCopy(`[昵称]`)">[昵称]</a-tag>
									</div>
								</a-form-item>
							</div>
							<a-divider :dashed="true" />
							<a-form-item label="自动群返利" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-switch
									v-decorator="['auto_group_rebate', { initialValue: false, valuePropName: 'checked' }]" />
							</a-form-item>
						
							<a-form-item label="开启佣金对比方案" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
								<a-switch
									v-decorator="['rebate_custom_service_charge_switch', { initialValue: false, valuePropName: 'checked' }]" />
							</a-form-item>
							<div v-show="formData['rebate_custom_service_charge_switch'] == true">
								<a-form-item label="拼多多查券返回CMS商城" help="如打开此开关，拼多多查券将会返回同款推荐，关闭则返回通用返利文案（回复设置）"
									:label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-switch
										v-decorator="['pdd_price_comparison_switch', { initialValue: false, valuePropName: 'checked' }]" />
								</a-form-item>
								<a-form-item label="跟发文案" v-show="formData['pdd_price_comparison_switch'] == true"
									:label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-textarea :rows="3" placeholder="请输入"
										v-decorator="['pdd_price_comparison_message', { initialValue: `您查询的商品被比价~` }]" />
									<div slot="extra">
										<a-tag @click="doCopy(`[昵称]`)">[昵称]</a-tag>
									</div>
								</a-form-item>
								<a-form-item label="淘宝/抖Y联盟服务费预扣除比例" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }" help="例如总佣金是10元，扣除10%，则按9元来算，抖Y在此基础上额外增加内置10%">
									<a-input-number :min="0"
										v-decorator="['rebate_custom_service_charge_unified', { initialValue: 10 }]"
										:formatter="value => `${value}%`" :parser="value => value.replace('%', '')" />
								</a-form-item>
								<a-form-item label="淘宝京东下单佣金小于查券佣金" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-radio-group
										v-decorator="['rebate_custom_service_charge_such', { initialValue: '1' }]">
										<a-radio :value="1">按查券佣金比例</a-radio>
										<a-radio :value="2">按下单佣金比例</a-radio>
									</a-radio-group>
								</a-form-item>
								<a-form-item label="淘宝京东下单佣金大于查券佣金" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-radio-group
										v-decorator="['rebate_custom_service_charge_choice', { initialValue: '1' }]">
										<a-radio :value="1">按查券佣金比例</a-radio>
										<a-radio :value="2">按下单佣金比例</a-radio>
									</a-radio-group>
								</a-form-item>
								<a-form-item label="多多进宝会员等级" help="说明：请根据您实际多多进宝后台等级设置，避免出现查询和付款用户返现不一致问题！"
									:label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
									:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
									<a-select v-model="pdd_level" placeholder="请选择" allowClear>
										<a-select-option value="0">V0等级-基础佣金率70%</a-select-option>
										<a-select-option value="1">V1等级-基础佣金率80%</a-select-option>
										<a-select-option value="2">V2等级-基础佣金率90%</a-select-option>
										<a-select-option value="3">V3等级-基础佣金率100%</a-select-option>
										<!-- <a-select-option value="2">V2及以上等级-基础佣金率100%</a-select-option> -->
									</a-select>
								</a-form-item>
							</div>

							<a-divider :dashed="true" />
							<a-form-item label="查券记录清理周期 （小时）" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
								:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }" extra="清理××小时前的查券记录缓存， 提高追单准确性">
								<a-input-number :min="1" :max="72"
									v-decorator="['clear_ticket_time', { initialValue: 10 }]" />
							</a-form-item>
					
				<a-divider :dashed="true" />

					<a-form-item label="选择机器人" :label-col="{ xs: { span: 24 }, sm: { span: 4 } }"
						:wrapper-col="{ xs: { span: 24 }, sm: { span: 10 } }">
						<robot-multiple v-decorator="['robotids', { rules: [{ required: true, message: '必填项' }] }]">
						</robot-multiple>
					</a-form-item>
					<a-form-item :wrapper-col="{ xs: { span: 12, offset: 0 }, sm: { span: 12, offset: 4 } }">
						<a-button htmlType="submit" @click="handleSubmit" type="primary">推送</a-button>
					</a-form-item>
				</a-form>
			</a-card>
		</a-spin>
		<domain-list-modal ref="domain_list" />
	</page-view>
</template>

<script>
import SearchRobotInput from '@/views/components/SearchRobotInput'
import TriggerTags from '@/views/components/TriggerTags'
import RobotMultiple from '@/views/components/RobotMultiple'
import DeviceApi from '@/api/device'
import { PageView } from '@/layouts'
import { mapActions } from 'vuex'
import DemoVideoAlert from '@/views/components/DemoVideoAlert'
import DomainListModal from './modules/DomainListModal'
import EmojiDialog from './components/EmojiDialog'
export default {
	name: 'PluginTicket',
	data() {
		return {
			pdd_level: '',
			form: this.$form.createForm(this, {
				onValuesChange: (_, values) => {
					Object.assign(this.formData, values)
				}
			}),
			tags: [],
			PullLoading: false,
			formData: {},
			robotid: null,
			domain_data: [],
			visible: false,
			minVisible: false,
			domainVisible: false,
			domainInfo: {},
			cardInfo: {},
			minProgramCardInfo: {},
			value: '1',
			sbtkl: '',
			sburl:'',
			sbpdd:'',
			sbjd:'',
			recognize_vph:'',
			sbdy:''
		}
	},
	components: {
		PageView,
		SearchRobotInput,
		TriggerTags,
		RobotMultiple,
		DemoVideoAlert,
		DomainListModal,
		EmojiDialog
	},
	created() {
		this.getData()
	},
	mounted() { },
	methods: {
		...mapActions(['BatchpushTask', 'TaskDrawerSwitch', 'demoSetVideo']),
		//切换tab
		// callback(key) {
		// 	this.getData()
		// },
		// 提交
		handleSubmit(e) {
			e.preventDefault()
			this.form.validateFields((err, values) => {
				values.activation_search_reward = values.activation_search_reward ? values.activation_search_reward : 0
				values.activation_deal_reward = values.activation_deal_reward ? values.activation_deal_reward : 0
				if (!err) {
					this.BatchpushTask({
						robotids: values.robotids,
						descs: '查券配置',
						apiFun: (sub_id) => {
							return DeviceApi.saveTicketSettingsInfo(
								Object.assign({ sub_id: sub_id }, this.domainInfo, this.cardInfo, this.minProgramCardInfo, values, { pdd_level: this.pdd_level })
							)
						}
					})
					this.TaskDrawerSwitch({ status: true })
					this.form.resetFields('robotids')
				}
			})
		},
		setEmoji(emoji, input) {
			var v = {}
			var elInput = this.$refs[input].$el // 根据id选择器选中对象
			var startPos = elInput.selectionStart // input 第0个字符到选中的字符
			// console.log(elInput)
			// console.log(elInput.selectionStart)
			// console.log(elInput.selectionEnd)
			var endPos = elInput.selectionEnd // 选中的字符到最后的字符
			if (startPos === undefined || endPos === undefined) return
			var txt = elInput.value
			// 将表情添加到选中的光标位置
			var result = txt.substring(0, startPos) + eval("'" + emoji + "'") + txt.substring(endPos)
			v[input] = result
			// console.log(v)
			this.form.setFieldsValue(v)
			// // 重新定义光标位置
			// elInput.focus()
			// elInput.selectionStart = startPos + emoji.length
			// elInput.selectionEnd = startPos + emoji.length
			// this.content = result // 赋值给表单中的的字段
		},
		settingDomain() {
			if (!this.domainVisible) this.domainVisible = true
			if (this.form.getFieldValue('domain_pool_switch')) {
				this.form.setFieldsValue(this.domainInfo)
			} else {
				setTimeout(() => {
					if (!this.domainInfo['domain_pool_switch']) {
						this.form.setFieldsValue(this.domainInfo)
					} else {
						this.settingDomain()
					}
				}, 300)
			}
		},
		minProgramShowModal() {
			const h = this.$createElement
			const modal = this.$info({
				title: '关于小程序中间页',
				content: h('div', {}, [
					h('img', {
						style: {
							width: '300px',
							cursor: 'pointer'
						},
						attrs: {
							src: 'https://nianchu-robot-yun-resource.oss-cn-hongkong.aliyuncs.com/image/centerpage.jpg'
						},
						on: {
							click: () => {
								window.open('https://nianchu-robot-yun-resource.oss-cn-hongkong.aliyuncs.com/image/centerpage.jpg', '_blank')
							}
						}
					})
					// h('div', '全部文案支持调用智能问答，文案中变量使用方法为：[智能标识id问答]。'),
					// h('div', '例如：[智能bx98yxna9z问答]'),
				])
			})
		},
		huifuChange(checkedValues) {
			// console.log('checked = ', checkedValues)
		},
		domainSettingOk() {
			this.domainInfo = {
				domain_pool_switch: this.form.getFieldValue('domain_pool_switch'),
				zjyurl: this.form.getFieldValue('zjyurl')
			}
			this.domainVisible = false
		},
		cardSettingOk() {
			this.cardInfo = {
				tb_card_title: this.form.getFieldValue('tb_card_title'),
				tb_card_desc: this.form.getFieldValue('tb_card_desc'),
				coupons_info: this.form.getFieldValue('coupons_info'),
				jd_card_title: this.form.getFieldValue('jd_card_title'),
				jd_card_desc: this.form.getFieldValue('jd_card_desc'),
				pdd_card_title: this.form.getFieldValue('pdd_card_title'),
				pdd_card_desc: this.form.getFieldValue('pdd_card_desc'),
				wph_card_title: this.form.getFieldValue('wph_card_title'),
				wph_card_desc: this.form.getFieldValue('wph_card_desc'),
				dy_card_title: this.form.getFieldValue('dy_card_title'),
				dy_card_desc: this.form.getFieldValue('dy_card_desc')
			}
			this.visible = false
		},
		minCardSettingOk() {
			this.minProgramCardInfo = {
				minProgram_card_title: this.form.getFieldValue('minProgram_card_title')
			}
			this.minVisible = false
		},
		settingCard() {
			if (!this.visible) this.visible = true
			if (this.form.getFieldValue('tb_card_title')) {
				this.form.setFieldsValue(this.cardInfo)
			} else {
				setTimeout(() => {
					if (!this.cardInfo['tb_card_title']) {
						this.form.setFieldsValue(this.cardInfo)
					} else {
						this.settingCard()
					}
				}, 300)
			}
		},
		settingMinProgramCard() {
			if (!this.minVisible) this.minVisible = true
			if (this.form.getFieldValue('minProgram_card_title')) {
				this.form.setFieldsValue(this.minProgramCardInfo)
			} else {
				setTimeout(() => {
					if (!this.minProgramCardInfo['minProgram_card_title']) {
						this.form.setFieldsValue(this.minProgramCardInfo)
					} else {
						this.settingMinProgramCard()
					}
				}, 300)
			}
		},
		getInt(rule, value, callback) {
			// const v = this.form.getFieldValue('promote_pay_delay')
			// console.log(value)
			if (!value) return callback()

			const prt = /^(([^0][0-9]+|0)$)|^(([1-9]+)$)/
			if (prt.test(value)) {
				callback()
			} else {
				callback(new Error('请输入一个大于等于1的整数'))
			}

			// console.log(rule, value)
			// const source = this.form.getFieldValue('source')
			// if (source != '1' && value != '1') {
			//   callback(new Error('非淘宝订单时请选择"全部状态"'))
			// }
			// callback()
			// const v = parseInt(value)
			// console.log(v)
			// if (isNaN(v)) return 1
			// if (v <= 1) {
			//   return 1
			// }
		},
		// 选择机器人
		onChangeRobotId(robotid) {
			this.robotid = robotid
			this.getData(robotid)
		},
		// 获取配置信息
		getData(robotid) {
			this.PullLoading = true
			DeviceApi.getTicketSettingInfo({ sub_id: robotid })
				.then((res) => {
					if (res.code === 1) {
						//console.log(res.data.sbtkl)
						this.form.setFieldsValue({
							hftxtimg: res.data.hftxtimg, // 是否回复商品图
							huifulx: res.data.huifulx, // 回复设置
							isok: res.data.isok, // 是否开启
							sbjd: res.data.sbjd, // 识别京东
							sbpdd: res.data.sbpdd, // 识别拼多多
							sbdy: res.data.sbdy === undefined ? true : res.data.sbdy, //识别抖Y
							recognize_vph: res.data.recognize_vph, // 识别唯品会
							sbtkl: res.data.sbtkl, // 识别淘口令
							sburl: res.data.sburl, // 识别商品链接
							userxz: res.data.userxz, // 查询设置
							zdgd_wh: res.data.zdgd_wh, // 是否追单
							sdfhlm: res.data.sdfhlm, // 首次查券使用副联盟
							reply_min_program: res.data.reply_min_program,
							is_dy_reply_text: res.data.is_dy_reply_text,
							min_program_page_type: res.data.min_program_page_type,
							min_program_cover_params: res.data.min_program_cover_params,  // 小程序自定义封面
							// super_zjyurl_switch: res.data.super_zjyurl_switch,
							identity_switch: res.data.identity_switch,
							identity_prefix: res.data.identity_prefix,
							identity_suffix: res.data.identity_suffix,
							message_delay: res.data.message_delay,
							taotitle: res.data.taotitle,
							promote_pay_switch: res.data.promote_pay_switch,
							promote_pay_delay: res.data.promote_pay_delay,
							promote_pay_num: res.data.promote_pay_num,
							promote_pay_message: res.data.promote_pay_message,
							promote_bind_switch: res.data.promote_bind_switch,
							promote_bind_delay: res.data.promote_bind_delay,
							promote_bind_message: res.data.promote_bind_message,
							// 激活用户促查开关
							active_switch: res.data.active_switch,
							active_expire_days: res.data.active_expire_days,
							active_message: res.data.active_message,
							activation_search_reward: res.data.activation_search_reward,
							activation_deal_reward: res.data.activation_deal_reward,
							auto_group_rebate: res.data.auto_group_rebate,
							No_coupon_reminder: res.data.No_coupon_reminder,
							// 有券消息提醒
							coupon_reminder: res.data.coupon_reminder,
							sub_union_order_num: res.data.sub_union_order_num,
							promote_search_switch: res.data.promote_search_switch,
							romote_search_delay: res.data.romote_search_delay,
							promote_search_one_message: res.data.promote_search_one_message,
							promote_search_two_message: res.data.promote_search_two_message,
							// promote_search_num: res.data.promote_search_num,
							promote_search_one_delay: res.data.promote_search_one_delay,
							promote_search_two_delay: res.data.promote_search_two_delay,
							pdd_price_comparison_switch: res.data.pdd_price_comparison_switch,
							pdd_price_comparison_message: res.data.pdd_price_comparison_message,
							rebate_custom_service_charge_switch: res.data.rebate_custom_service_charge_switch,
							rebate_custom_service_charge_unified: res.data.rebate_custom_service_charge_unified,
							rebate_custom_service_charge_such: res.data.rebate_custom_service_charge_such,
							rebate_custom_service_charge_choice: res.data.rebate_custom_service_charge_choice,
							first_order_extend_switch: res.data.first_order_extend_switch, // 首次查券
							first_order_extend_time: res.data.first_order_extend_time,
							first_order_extend_content: res.data.first_order_extend_content,
							clear_ticket_time: res.data.clear_ticket_time

						})
						this.cardInfo = {
							tb_card_title: res.data.tb_card_title,
							tb_card_desc: res.data.tb_card_desc,
							coupons_info: res.data.coupons_info,
							jd_card_title: res.data.jd_card_title,
							jd_card_desc: res.data.jd_card_desc,
							pdd_card_title: res.data.pdd_card_title,
							pdd_card_desc: res.data.pdd_card_desc,
							wph_card_title: res.data.wph_card_title,
							wph_card_desc: res.data.wph_card_desc,
							// 抖Y
							dy_card_title: res.data.dy_card_title,
							dy_card_desc: res.data.dy_card_desc
						}
						this.minProgramCardInfo = {
							minProgram_card_title: res.data.minProgram_card_title
						}
						this.domainInfo = {
							domain_pool_switch: res.data.domain_pool_switch,
							pages_type: res.data.pages_type,
							zjyurl: res.data.zjyurl // 中间页url
						}
						this.pdd_level = res.data.pdd_level
					} else {
						this.$message.error(res.msg)
					}
				})
				.finally(() => {
					this.PullLoading = false
				})
		},
		doCopy(text) {
			this.$copyText(text)
				.then((message) => {
					this.$message.success('复制完毕')
				})
				.catch((err) => {
					this.$message.error('复制失败')
				})
		}
	}
}
</script>
<style lang="less" scoped>
/deep/ .page-header {
	.extra {
		display: none;
	}

	.headerContent {
		flex: 0 1 100% !important;
	}
}

/deep/ .ant-card-extra {
	padding: 0;
}

.qEmoji {
	background: url(../components/emoji/images/1.png);
	height: 25px;
	width: 25px;
	margin: 0 auto;
}

.eList {
	background: url(../components/emoji/images/2.png);
	height: 25px;
	width: 25px;
	margin: 0 auto;
}
</style>
